import fullpage from "fullpage.js";
import Scrollbar from "smooth-scrollbar";
import { splitText } from "../utils/splitText";
import gsap from "gsap";

const project_controls = () => {
	const projects = [...document.querySelectorAll(".projects li")];

	setupProjectVisibilityObserver(projects);
};

const setupProjectVisibilityObserver = (projects) => {
	const options = {
		root: null,
		rootMargin: "0px", // Ajustez la marge ici si nécessaire
		threshold: 1, // Ajustez le seuil ici pour détecter le passage par le centre
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const intersectionRatio = entry.intersectionRatio;
			if (intersectionRatio >= options.threshold) {
				entry.target.classList.add("active");
			} else {
				entry.target.classList.remove("active");
			}
		});
	}, options);

	projects.forEach((project) => {
		observer.observe(project);
	});
};

const video_controls = () => {
	const videos = [...document.querySelectorAll("video")];

	if(window.innerWidth <= 600){
		videos.forEach(video => {
			const sdQuality = video.getAttribute('sd-source') ? video.getAttribute('sd-source') : false;
			if(sdQuality){
				video.querySelector('source').src = sdQuality
				video.removeAttribute('sd-source')
			}
		});
	}


	setupVideoVisibilityObserver(videos);
};

const setupVideoVisibilityObserver = (videos) => {
	const options = {
		root: null,
		rootMargin: "0px",
		threshold: [0, 1],
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const has_source = entry.target.querySelector("source")
				? true
				: false;

			if (entry.isIntersecting) {
				if (has_source) {
					entry.target.play();
				}
			} else {
				if (has_source) {
					entry.target.pause();
				}
			}
		});
	}, options);

	videos.forEach((video) => {
		observer.observe(video);
	});
};

const titles_anim = () => {
	const descriptionsIntroduction = [
		...document.querySelectorAll(".home section.introduction"),
	];
	setupDescriptionsIntroductionVisibilityObserver(descriptionsIntroduction);
};

const setupDescriptionsIntroductionVisibilityObserver = (
	descriptionsIntroduction
) => {
	const options = {
		root: null,
		rootMargin: "0px", // Ajustez la marge ici si nécessaire
		threshold: 1, // Ajustez le seuil ici pour détecter le passage par le centre
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const intersectionRatio = entry.intersectionRatio;
			if (intersectionRatio >= options.threshold) {
				entry.target.querySelector(".title").classList.add("active");

				gsap.fromTo(
					entry.target.querySelectorAll(".title span"),
					{
						opacity: 0,
					},
					{
						duration: 1,
						opacity: 1,
						ease: "power1.inOut",
						stagger: {
							amount: 0.5,
						},
					}
				);
			} else {
				gsap.to(entry.target.querySelectorAll("span"), {
					duration: 0.2,
					opacity: 0,
					ease: "power1.inOut",
					stagger: {
						amount: 0.5,
					},
				});

				entry.target.classList.remove("active");
			}
		});
	}, options);

	descriptionsIntroduction.forEach((description) => {
		splitText(description.querySelector('.title'));
		observer.observe(description);
	});
};

class HorizontalScrollPlugin extends Scrollbar.ScrollbarPlugin {
	static pluginName = "horizontalScroll";

	transformDelta(delta, fromEvent) {
		if (scrollX) {
			if (!/wheel/.test(fromEvent.type)) {
				return delta;
			}

			const { x, y } = delta;

			return {
				y: 0,
				x: Math.abs(x) > Math.abs(y) ? x : y * 3,
			};
		}
	}
}

const scrollingSpeed = 800;

document.documentElement.style.setProperty(
	"--scrollingSpeed",
	`${scrollingSpeed / 1000}s`
);

let timerId;
let scrollX = false;
if (window.innerWidth <= 600) {
	scrollX = true;
}
const timer = () => {
	timerId = setTimeout(() => {
		activeFP(false);
	}, scrollingSpeed - 200);
};

const activeFP = (on) => {
	fullpage_api.setAllowScrolling(on);
	scrollX = !on;
};
let sc = null;
let fp = null;

const CheckIsSelection = () => {
	if (localStorage.getItem("selection") === "true") {
		const sectionSelection = document.querySelector("section.projects");
		if (!sectionSelection) return false;



		localStorage.removeItem("selection");
		if (fp && typeof fp.moveTo !== "undefined") {
			// fp.moveTo(index);


			let mobile = false;
			if (window.innerWidth <= 600) {
				mobile = true;
			}
			let index = Array.from(
				sectionSelection.parentNode.children
			).indexOf(sectionSelection);

			if (!mobile) {
				index = index - 1;
			}

			fp.silentMoveTo(index);
			localStorage.removeItem('selection')
		}
		return true;
	}
};

const removeLazyLoading = () =>{
	setTimeout(() => {
		const allImages = [...document.querySelectorAll('img')]
		allImages.forEach(element => {
			element.removeAttribute('loading')
		});
	}, 2000);

}

if (document.querySelector(".home")) {
	project_controls();
	removeLazyLoading();
	// document.querySelector("video").play();

	var playPromise = document.querySelector("video").play();

	if (playPromise !== undefined) {
	  playPromise.then(_ => {
		// Automatic playback started!
		// Show playing UI.
	  })
	  .catch(error => {
		// Auto-play was prevented
		// Show paused UI.
	  });
	}



	video_controls();
	titles_anim();
	Scrollbar.use(HorizontalScrollPlugin);
	sc = Scrollbar.init(
		document.querySelector(".projects .wrapper-selection"),
		{
			damping: 0.08,
			delegateTo: document.documentElement,
		}
	);

	sc.addListener((e) => {
		if (e.offset.x == 0) {
			if (window.innerWidth > 600) {
				activeFP(true);
				fullpage_api.moveSectionUp();
			}
		} else if (e.offset.x == e.limit.x) {
			if (window.innerWidth > 600) {
				activeFP(true);
				fullpage_api.moveSectionDown();
			}
		}
	});
	const parallax = (origin, destination, direction) => {
		if (!origin.item.classList.contains("introduction")) {
			return false;
		}
		if (
			destination.item.classList.contains("manifest") &&
			window.innerWidth > 600
		) {
			if (direction == "down") {
				origin.item.querySelector(
					".content"
				).style.transform = `translateY(0%)`;
			}
		} else {
			if (direction == "down") {
				origin.item.querySelector(
					".content"
				).style.transform = `translateY(20%)`;
			} else if (direction == "up") {
				destination.item.querySelector(
					".content"
				).style.transform = `translateY(0%)`;
			}
		}
	};

	fp = new fullpage(".home", {
		autoScrolling: true,
		scrollHorizontally: true,
		sectionSelector: "section",
		scrollingSpeed: scrollingSpeed,
		licenseKey: document
			.querySelector('[name="fullpagekey"]')
			.getAttribute("key"),

		onLeave: (origin, destination, direction) => {
			parallax(origin, destination, direction);
			if (
				destination.item.classList.contains("projects") &&
				window.innerWidth > 600
			) {
				clearTimeout(timerId);
				timer();
				if (direction == "down") {
					sc.scrollTo(1, 0, 600);
				} else {
					sc.scrollTo(sc.limit.x - 1, 0, 600);
				}
			}

			// Paginations
			const lenghtIntroduction = [
				...document.querySelectorAll(".introduction"),
			].length;
			if (destination.index < lenghtIntroduction) {
				document
					.querySelector(".homepage .paginations")
					.classList.remove("hide");

				const indexOrigin = origin.index + 1;
				const indexDestination = destination.index + 1;

				const elOrigin = document.querySelector(
					".homepage .paginations li:nth-child(" + indexOrigin + ")"
				);
				const elDestination = document.querySelector(
					".homepage .paginations li:nth-child(" +
						indexDestination +
						")"
				);

				if (elOrigin) {
					elOrigin.classList.remove("active");
				}
				if (elDestination) {
					elDestination.classList.add("active");
				}
			} else {
				document
					.querySelector(".homepage .paginations")
					.classList.add("hide");
			}
		},
	});
	window.fp = fp;

	CheckIsSelection();
}
